import clsx from 'clsx';
import * as React from 'react';
import { colors } from '@ovpn-ui/styles';
import { ChevronRight } from '@ovpn-ui/icons';
import { polymorphicAsProp } from '../types';
import * as Styled from './Breadcrumbs.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Breadcrumbs = /*#__PURE__*/React.forwardRef(function Breadcrumbs({
  as = 'nav',
  children,
  className,
  ...props
}, ref) {
  const length = React.Children.count(children);
  return /*#__PURE__*/_jsx("nav", {
    ...polymorphicAsProp(as),
    ref: ref,
    role: "navigation",
    "aria-label": "breadcrumbs",
    className: clsx('ovpn-breadcrumbs', className),
    ...props,
    children: /*#__PURE__*/_jsx(Styled.Breadcrumbs, {
      className: "ovpn-breadcrumbs-list",
      children: React.Children.map(children, (child, index) => /*#__PURE__*/_jsxs(Styled.Breadcrumb, {
        className: "ovpn-breadcrumbs-item",
        children: [/*#__PURE__*/React.cloneElement(child, {
          key: `breadcrumb-${String(index)}`,
          className: 'ovpn-breadcrumbs-item-element',
          'aria-current': index === length - 1 ? 'page' : undefined
        }), index < length - 1 && /*#__PURE__*/_jsx(ChevronRight, {
          size: "sm",
          color: colors.neutralTextSubtitle,
          className: clsx('ovpn-breadcrumbs-item-icon')
        })]
      }))
    })
  });
});
export default Breadcrumbs;